import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@clarkinc/zest-design-system/ui";

const urlsToExclude = [
  "www.mozilla.org",
  "www.google.com",
  "www.facebook.com",
  "twitter.com",
  "policies.google.com",
  "www.clarkassociatesinc.biz",
  "www.lancastertableandseating.com",
  "www.instagram.com",
  "www.youtube.com",
  "www.tiktok.com",
  "www.pinterest.com",
  "pinterest.com",
  "get.adobe.com",
  "youtu.be",
  "webstaurantstore.com",
  "www.webstaurantstore.com",
  "dev.webstaurantstore.com",
  "www.dev.webstaurantstore.com",
  "versahub.com",
  "wwww.versahub.com",
  "dev.versahub.com",
  "www.dev.versahub.com",
  "cdnimg.webstaurantstore.com",
  "tfs.clarkinc.biz",
  "teams.microsoft.com",
  "apps.apple.com",
  "play.google.com",
  "www.firstbankcard.com",
  "www.card.fnbo.com",
  "www.fedex.com",
  "www.bettertrucks.com",
  "ship.cdldelivers.com",
  "west.ontrac.com",
  "www.ups.com",
  "aduiepyle.com",
  "www.aaacooper.com",
  "arcb.com",
  "www.amodei.com",
  "orbit.choptanktransport.com",
  "beta.shipcc.com",
  "daytonfreight.com",
  "www.estes-express.com",
  "us.kuehne-nagel.com",
  "www.mainchain.net",
  "www.oakh.com",
  "www.odfl.com",
  "pittohio.com",
  "www.rlcarriers.com",
  "www.shiproadrunnerfreight.com",
  "www.saia.com",
  "www.sefl.com",
  "www.wardtlc.com",
  "ext-web.ltl-xpo.com",
  "east.dicom.com",
  "www.nonstopdelivery.com",
  "www.datstrucking.com",
  "www.newpenn.com",
  "www.rrts.com",
  "ltl.upsfreight.com",
  "www.reddawayregional.com",
  "www.yrc.com",
  "www.centralfreight.com",
  "www.smtl.com",
  "www.centraltransportint.com",
  "www.yrcregional.com",
  "ltl.xpo.com",
  "www.mainfreight.com",
  "auth.ccfs.com",
  "mypyle.aduiepyle.com",
  "my.reddawayregional.com",
  "tools.rrts.com",
  "my.hollandregional.com",
  "pod.easternconnection.com",
  "www-1.datstrucking.com",
  "www.tforcefreight.com",
  "my.yrc.com",
] as const;

const shouldShowModal = (link: HTMLAnchorElement) => {
  return (
    link.host &&
    link.host !== window.location.host &&
    !urlsToExclude.includes(link.host)
  );
};

const visitLink = (link: string) => {
  window.open(link, "_blank");
};

function ExternalLinkModal() {
  const [externalLink, setExternalLink] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const onLinkClick = (e: Event) => {
    e.preventDefault();
    let aLink = e.target;
    if (!(aLink instanceof HTMLAnchorElement) && aLink instanceof Element) {
      aLink = aLink.parentElement;
    }
    if (aLink instanceof HTMLAnchorElement) {
      setExternalLink(aLink.href);
      setIsOpen(true);
    }
  };

  useEffect(() => {
    let links: (() => void)[] = [];

    const setupLinks = () => {
      // remove existing event listeners
      for (const fn of links) {
        fn();
      }

      // setup new links array to store event listeners for cleanup
      links = [];

      const externalLinks = document.getElementsByTagName("a");

      for (const link of externalLinks) {
        if (shouldShowModal(link)) {
          link.addEventListener("click", onLinkClick);

          links.push(() => link.removeEventListener("click", onLinkClick));
        }
      }
    };

    setupLinks();

    window.addEventListener("resourcesLoaded", setupLinks);

    return () => {
      window.removeEventListener("resourcesLoaded", setupLinks);

      for (const fn of links) {
        fn();
      }
    };
  }, []);

  return (
    <Modal
      open={isOpen}
      onOpenChange={setIsOpen}
      id="external-link-modal"
      theme="wss"
      aria-label="Alert: External Link"
      /* Please note: Zest modal will already handle aria-labelledby internally. This modal is being treated as an
        alert dialog and needed different naming conventions. In most cases don't do this below. */
      aria-labelledby={undefined}
    >
      <ModalHeader>External Link</ModalHeader>
      <ModalBody>
        <p>
          You are about to leave the security of WebstaurantStore.com.
          <br aria-hidden="true" />
          <br aria-hidden="true" />
          We are not responsible for the privacy policy or any content, links or
          software, or any consequences from your access to or use of the
          technologies, websites, information and programs made available on
          this new site.
          <br aria-hidden="true" />
          <br aria-hidden="true" />
          Do you want to proceed?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button
          color="gray"
          variant="secondary"
          onClick={() => setIsOpen(false)}
        >
          Go Back
        </Button>
        <Button
          onClick={() => {
            visitLink(externalLink);
            setIsOpen(false);
          }}
        >
          Visit Link
        </Button>
      </ModalFooter>
    </Modal>
  );
}
export default ExternalLinkModal;
